/* A session countdown for choosing items; it never reserves stock or clears a cart. */
(() => {
 const tiers = [{quantity:2,percent:10},{quantity:3,percent:15},{quantity:4,percent:20},{quantity:5,percent:25}];
 const tierState = quantity => {
  const count = Math.max(0, Math.floor(Number(quantity) || 0));
  const current = [...tiers].reverse().find(tier => count >= tier.quantity);
  const next = tiers.find(tier => count < tier.quantity);
  return {quantity:count,percent:current?.percent || 0,nextQuantity:next?.quantity || 0,nextPercent:next?.percent || 0,remaining:next ? next.quantity-count : 0};
 };
 const renderTierProgress = () => document.querySelectorAll('[data-ep-cart-tier-progress]').forEach(progress => {
  const state = tierState(progress.getAttribute('data-cart-quantity'));
  const current = progress.querySelector('[data-ep-cart-tier-current]');
  const next = progress.querySelector('[data-ep-cart-tier-next]');
  const currentCopy = state.percent ? `${state.quantity} Artikel: ${state.percent} % Mengenrabatt.` : `Ihre Auswahl: ${state.quantity} Artikel.`;
  const nextCopy = state.nextQuantity ? `Noch ${state.remaining} Artikel für ${state.nextPercent} % Mengenrabatt.` : 'Höchster Mengenrabatt erreicht.';
  if(current && current.textContent !== currentCopy) current.textContent = currentCopy;
  if(next && next.textContent !== nextCopy) next.textContent = nextCopy;
 });
 const key = 'emma-cart-choice-until';
 const duration = 10 * 60 * 1000;
 let deadline = 0;
 const read = () => { try { return Number(sessionStorage.getItem(key)) || 0; } catch { return deadline; } };
 const store = value => { deadline = value; try { value ? sessionStorage.setItem(key, String(value)) : sessionStorage.removeItem(key); } catch {} };
 const render = () => {
  renderTierProgress();
  const drawer = document.getElementById('cart-drawer');
  const total = drawer?.querySelector('[data-cart-total]');
  if (total && window.theme?.formatMoney) {
   const cents = Number(total.getAttribute('data-cart-total'));
   if (Number.isFinite(cents)) {
    const amount = window.theme.formatMoney(cents, window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat);
    const label = 'Zur Kasse • ' + amount;
    drawer.querySelectorAll('[data-ep-checkout-label]').forEach(button => {
     if (button.getAttribute('data-ep-checkout-label') !== label) button.setAttribute('data-ep-checkout-label', label);
     if (button.textContent !== label) button.textContent = label;
    });
   }
  }
  const bar = drawer?.querySelector('#cd-timer-bar');
  const clock = drawer?.querySelector('#cd-timer');
  if (!bar || !clock) return;
  if (drawer.classList.contains('is-empty')) {store(0);if(!bar.classList.contains('is-hidden')) bar.classList.add('is-hidden');return;}
  const until = read();
  if (!until) store(Date.now()+duration);
  const remaining = Math.max(0, Math.ceil(((until || deadline)-Date.now())/1000));
  const display = `${String(Math.floor(remaining/60)).padStart(2,'0')}:${String(remaining%60).padStart(2,'0')}`;
  if(clock.textContent !== display) clock.textContent = display;
  if(bar.classList.contains('is-hidden')) bar.classList.remove('is-hidden');
 };
 document.addEventListener('theme:cart:change', render);
 document.addEventListener('theme:cart:loaded', render);
 document.addEventListener('visibilitychange', render);
 const drawer = document.getElementById('cart-drawer');
 if (drawer) new MutationObserver(render).observe(drawer,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
 setInterval(render,1000);
 render();
})();